var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchievement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 245,
    r: 245,
    fill: "#8783d1",
    opacity: 1,
    "data-original": "#26a6fe",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 245,
    r: 200,
    fill: "#a4a1da",
    opacity: 1,
    "data-original": "#01c0fa",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fd5426",
    d: "m119.084 486.349 28.706 1.187a17.081 17.081 0 0 0 17.205-12.646l64.176-239.507-40.815-10.936a4 4 0 0 0-4.899 2.829l-68.07 254.043c-.664 2.473 1.138 4.924 3.697 5.03z",
    opacity: 1,
    "data-original": "#fd5426",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe7701",
    d: "m284.064 250.091-67.784-18.163-68.49 255.607 20.231.836c.59.024 1.167.179 1.69.453l43.392 22.716a4 4 0 0 0 5.719-2.508l68.071-254.043a4 4 0 0 0-2.829-4.898z",
    opacity: 1,
    "data-original": "#fe7701",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe7701",
    d: "m272.257 238.216-44.321 11.875a4 4 0 0 0-2.828 4.899l68.071 254.043a4 4 0 0 0 5.719 2.508l27.722-14.513a18.528 18.528 0 0 0 9.304-21.21z",
    opacity: 1,
    "data-original": "#fe7701",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fb8801",
    d: "M328.543 227.275a4 4 0 0 0-4.899-2.829l-65.969 17.676 68.381 255.201 16.232-8.498a4.02 4.02 0 0 1 1.69-.453l48.937-2.023a4 4 0 0 0 3.698-5.032z",
    opacity: 1,
    "data-original": "#fb8801",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fed402",
    d: "M395 310c-131.455 0-238.729-103.53-244.735-233.5-.209-4.525-3.405-8.269-7.763-9.507l-.077-.022c-14.692-4.234-28.667 8.559-25.745 23.567 2.351 12.074-6.408 23.477-18.68 24.319-15.254 1.046-24.011 17.847-16.132 30.951 6.339 10.542 2.008 24.253-9.236 29.241-13.976 6.2-16.459 24.983-4.573 34.601 9.562 7.738 10.182 22.104 1.322 30.636-11.013 10.606-6.922 29.105 7.537 34.079 11.632 4.001 17.128 17.288 11.721 28.336l-1.031 4.125c-3.482 13.926 5.415 25.32 19.77 25.32 12.299-.219 22.008 10.388 20.706 22.619-1.619 15.204 13.406 26.745 27.679 21.261 11.482-4.412 24.233 2.234 27.193 14.173 3.679 14.841 21.745 20.547 33.282 10.512 9.281-8.073 23.536-6.189 30.401 4.018 7.085 10.535 21.338 11.759 30.211 4.214 9.025-7.674 20.215-12.341 32.062-12.341h2.539c12.358 9.004 29.865 1.762 32.252-13.34 1.92-12.15 14.051-19.869 25.871-16.463 14.692 4.234 28.667-8.559 25.745-23.567-2.351-12.074 6.408-23.477 18.68-24.319a20.47 20.47 0 0 0 7.62-2.018c4.26-2.082 2.288-8.537-2.431-8.075A247.586 247.586 0 0 1 395 310z",
    opacity: 1,
    "data-original": "#fed402",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fee903",
    d: "M443.939 224.121c-9.562-7.738-10.182-22.104-1.322-30.636 11.013-10.607 6.922-29.106-7.537-34.079-11.632-4.001-17.128-17.288-11.721-28.337 6.721-13.734-3.451-29.718-18.738-29.446-12.299.219-22.008-10.387-20.706-22.619 1.619-15.204-13.406-26.745-27.679-21.261-11.482 4.412-24.233-2.234-27.193-14.173-3.679-14.841-21.745-20.547-33.282-10.512-9.281 8.073-23.536 6.189-30.401-4.018-8.533-12.687-27.461-11.871-34.87 1.505-5.96 10.76-20 13.865-29.941 6.622-12.358-9.004-29.865-1.762-32.252 13.34-1.92 12.15-14.051 19.869-25.871 16.463a21.13 21.13 0 0 0-2.28-.523c-.097 2.84-.146 5.691-.146 8.553 0 135.31 109.69 245 245 245a247 247 0 0 0 35.325-2.528c11.159-4.508 16.515-18.349 9.805-29.508-6.339-10.542-2.008-24.253 9.236-29.241 13.976-6.201 16.458-24.983 4.573-34.602z",
    opacity: 1,
    "data-original": "#fee903",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fea713",
    d: "M347.4 271.487c-80.676.001-146.001-65.322-146.002-145.999 0-12.586 1.592-24.799 4.587-36.451 1.128-4.388-3.245-8.209-7.41-6.425-52.084 22.304-88.575 74.026-88.576 134.272-.001 80.556 65.446 146.002 146.002 146.002 60.144-.001 111.793-36.368 134.158-88.311 1.838-4.269-2.086-8.75-6.591-7.602a146.304 146.304 0 0 1-36.168 4.514z",
    opacity: 1,
    "data-original": "#fea713",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fac600",
    d: "M256 70.885c-20.767 0-40.521 4.336-58.406 12.151-7.815 17.885-12.151 37.639-12.151 58.406 0 80.634 65.366 146 146 146 20.767 0 40.521-4.336 58.406-12.151 7.815-17.886 12.151-37.64 12.151-58.406 0-80.633-65.366-146-146-146z",
    opacity: 1,
    "data-original": "#fac600",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01c0fa",
    d: "M372 216.886c0 22.159-6.214 42.867-16.993 60.476a19.088 19.088 0 0 1-6.308 6.308c-17.609 10.779-38.317 16.993-60.476 16.993-63.852.001-116.001-52.149-116.001-116.001 0-22.15 6.209-42.85 16.98-60.454a19.179 19.179 0 0 1 6.342-6.342c17.605-10.771 38.305-16.98 60.455-16.98 63.852-.001 116.002 52.148 116.001 116z",
    opacity: 1,
    "data-original": "#4f66d0",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26a6fe",
    d: "M356.093 275.55c-20.15 34.305-57.432 57.335-100.093 57.335-64.065 0-116-51.935-116-116 0-42.661 23.03-79.943 57.335-100.093-10.109 17.212-15.907 37.261-15.907 58.665 0 64.065 51.935 116 116 116 21.404 0 41.454-5.798 58.665-15.907z",
    opacity: 1,
    "data-original": "#314dc9",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe5c2",
    d: "M256 215.183c16.569 0 30-13.431 30-30v-10c0-16.569-13.431-30-30-30-16.569 0-30 13.431-30 30v10c0 16.569 13.431 30 30 30z",
    opacity: 1,
    "data-original": "#ffe5c2",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5dd39e",
    d: "M210.379 288.587h91.242a5 5 0 0 0 5-5v-25c0-16.569-13.431-30-30-30h-41.242c-16.569 0-30 13.431-30 30v25a5 5 0 0 0 5 5z",
    opacity: 1,
    "data-original": "#05e39c",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievement);
export default __webpack_public_path__ + "static/media/achievement.8ec3a4b1a4761d1d3d3ff7197b4bd242.svg";
export { ForwardRef as ReactComponent };